/* Tema-bannere (liggende 130 × 40): enhjørning, dinosaur, … — tillegg til br-banner-render.js, samme mønster som br-babyshower.js.
   Hvert tema = ferdig komponert illustrasjon (egen Recraft-tegning) 8125 × 2500 px på Shopify CDN + tekstfarger.
   Tekst: linje 1 store bokstaver i fargemiks (Baloo 2), linje 2 navn i Pacifico (størst), linje 3 fargemiks.
   Linje 3 finnes ikke i designeren fra før, så feltet legges inn her og sendes med som «Linje 3».
   Nytt tema: legg til i shop-metafeltet custom.banner_design (ingen temaendring nødvendig). */
(function (root) {
  if (root.__brTema) return; root.__brTema = 1;   // lastes bare én gang selv om flere maler tar den med
  const CDN = 'https://cdn.shopify.com/s/files/1/0526/7419/9720/files/';
  const TEMA = {
    unicorn_pastell: { name: 'Enhjørning pastell', bg: CDN + 'unicorn-banner-illustrasjon.jpg?v=1792920140', navn: '#E79BB8', l3: '5 år',
      farger: ['#F2A9C2', '#F7C6D6', '#F2CE5E', '#A6C98C', '#A3BDEB', '#CDB4EA'] },
    dino_gronn: { name: 'Dinosaur grønn', bg: CDN + 'dino-banner-illustrasjon.jpg?v=1792929462', navn: '#7AAA6E', l3: '4 år',
      farger: ['#7EAA7C', '#7FA8C4', '#96C8BA', '#66968C', '#A0C4DE', '#A6C68A'] },
    rom_mork: { name: 'Verdensrom mørkeblå', bg: CDN + 'rom-banner-mork-illustrasjon.jpg?v=1792934597', fill: '#2C3864', navn: '#F6D46B', l3: '6 år',
      farger: ['#A9C3F0', '#F6D46B', '#CDB8EC', '#BFE3C8', '#F8C7A8', '#F0F0FA'] },
    rom_lys: { name: 'Verdensrom lys', bg: CDN + 'rom-banner-lys-illustrasjon.jpg?v=1792934597', navn: '#6F86B8', l3: '6 år',
      farger: ['#6F86B8', '#A9C3F0', '#CDB8EC', '#E8C45C', '#8CA0CD', '#B8AAE2'] },
    safari_sand: { name: 'Safari sand', bg: CDN + 'safari-banner-illustrasjon.jpg?v=1792935767', fill: '#F4E8D2', navn: '#C4764A', l3: '3 år',
      farger: ['#C87A50', '#C49646', '#8C9B5F', '#78A076', '#D68C64', '#A57650'] },
    hbarn_lavendel: { name: 'Søt Halloween', bg: CDN + 'halloween-barn-banner-illustrasjon.jpg?v=1792948989', fill: '#F6F1F8', navn: '#E2804A', l3: '6 år',
      farger: ['#E2804A', '#9678BE', '#6EAA96', '#E19678', '#B48CC8', '#787082'] }
  };
  // Nye design uten temaendring: shop-metafelt custom.banner_design → window.BR_EXTRA = { tema: {id: {...}}, art: {id: {...}} }
  const X = root.BR_EXTRA || {};
  Object.assign(TEMA, X.tema || {});
  const ART = X.art || {};
  try {
    const l = document.createElement('link'); l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700&family=Pacifico&display=block';
    (document.head || document.documentElement).appendChild(l);
    const st = document.createElement('style');
    st.textContent =
      '.br:has(.br-prev svg[data-tema]) #br-fontbox,' +
      '.br:has(.br-prev svg[data-tema]) .br-label:has(+ #br-photoyn),.br:has(.br-prev svg[data-tema]) #br-photoyn,' +
      '.br:has(.br-prev svg[data-tema]) #br-upload{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const F1 = { css: "'Baloo 2'", weight: 700 }, F2 = { css: 'Pacifico', weight: 400 };
  let _ctx;
  function measure(text, f, size, ls) {
    _ctx = _ctx || document.createElement('canvas').getContext('2d');
    _ctx.font = `${f.weight} ${size}px ${f.css}`;
    const m = _ctx.measureText(text);
    const w = m.width + ls * Math.max(0, [...text].length - 1);
    const asc = m.actualBoundingBoxAscent || size * 0.7, desc = m.actualBoundingBoxDescent || 0;
    return { w, asc, desc };
  }
  function l3val(o, T) {
    if (o.l3 != null) return o.l3;
    if (typeof document === 'undefined') return T.l3;
    const el = document.getElementById('br-l3');
    if (!el) return T.l3;
    if (el.value.trim()) return el.value;
    const v = id => ((document.getElementById(id) || {}).value || '').trim();
    return (v('br-l1') || v('br-l2')) ? '' : T.l3;   // eksempeltekst bare når kunden ikke har skrevet noe
  }

  // Oppsettet er målt i mm på 1300 × 400 (skisse unicorn-v4, 25.10.2026)
  function layout(o, T, W, H, b) {
    const k = H / 400, maxw = 634 * W / 1300, gap = 24 * k;
    let s = `<rect x="${-b}" y="${-b}" width="${W + 2*b}" height="${H + 2*b}" fill="${T.fill || '#FFFFFF'}"/>`;
    s += `<image href="${T.bg}" xlink:href="${T.bg}" x="0" y="0" width="${W}" height="${H}" preserveAspectRatio="none"${T.fill ? '' : ' style="mix-blend-mode:multiply"'}/>`;
    const lines = [
      { t: (o.l1 || '').trim().toLocaleUpperCase('nb'), f: F1, size: 88 * k, ls: 1.6 * k, mix: true },
      { t: (o.l2 || '').trim(), f: F2, size: 120 * k, ls: 0, mix: false },
      { t: (l3val(o, T) || '').trim(), f: F1, size: 56 * k, ls: 1.6 * k, mix: true }
    ].filter(x => x.t);
    if (!lines.length) return s;
    lines.forEach(x => {
      let m = measure(x.t, x.f, x.size, x.ls);
      if (m.w > maxw) { const r = maxw / m.w; x.size *= r; x.ls *= r; m = measure(x.t, x.f, x.size, x.ls); }
      x.m = m;
    });
    const tot = lines.reduce((a, x) => a + x.m.asc + x.m.desc, 0) + gap * (lines.length - 1);
    let y = (H - tot) / 2 + 16 * k;
    const cx = W / 2;
    let ci = 0;
    lines.forEach(x => {
      const base = y + x.m.asc;
      const attrs = `x="${cx}" y="${base}" text-anchor="middle" font-family="${x.f.css}" font-weight="${x.f.weight}" font-size="${x.size}"${x.ls ? ` letter-spacing="${x.ls}"` : ''}`;
      if (x.mix) {
        let sp = '';
        for (const ch of x.t) {
          if (ch === ' ') { sp += ' '; continue; }
          sp += `<tspan fill="${T.farger[ci++ % T.farger.length]}">${esc(ch)}</tspan>`;
        }
        s += `<text ${attrs} xml:space="preserve">${sp}</text>`;
      } else {
        s += `<text ${attrs} fill="${T.navn}">${esc(x.t)}</text>`;
      }
      y += x.m.asc + x.m.desc + gap;
    });
    return s;
  }

  function marks(o, W, H, b) {
    if (!o.marks) return '';
    let s = ''; const g = 25;
    if (o.maljer !== false) [g, H - g].forEach(yy => [g, W - g].forEach(xx => {
      s += `<circle cx="${xx}" cy="${yy}" r="1.5" fill="none" stroke="#888" stroke-width="0.25"/><path d="M${xx-2.5} ${yy}H${xx+2.5}M${xx} ${yy-2.5}V${yy+2.5}" stroke="#888" stroke-width="0.25"/>`;
    }));
    const k = 'stroke="#000" stroke-width="0.25"';
    [[0, 0, -1, -1], [W, 0, 1, -1], [0, H, -1, 1], [W, H, 1, 1]].forEach(([x, y, dx, dy]) => {
      s += `<path d="M${x + dx*(b+2)} ${y}H${x + dx*(b+10)}M${x} ${y + dy*(b+2)}V${y + dy*(b+10)}" ${k}/>`;
    });
    if (o.order) s += `<text x="${-b}" y="${-b-4}" font-family="Helvetica,Arial,sans-serif" font-size="4" fill="#000">${esc(o.order)}</text>`;
    return s;
  }

  let _n = 0;
  function patch(BR) {
    if (!BR || BR.__tema) return BR;
    BR.__tema = true;
    BR.FONTS.pacifico = BR.FONTS.pacifico || { name: 'Pacifico', css: 'Pacifico', weight: 400, cap: 0.7 };
    Object.keys(TEMA).forEach(id => {
      const T = TEMA[id];
      BR.DESIGNS[id] = {
        name: T.name, swatch: T.farger[0], tema: id, font: 'pacifico', fastFont: true, max1: 24, max2: 14,
        colors: { l1: T.navn, l2: T.navn }, photo: { cx: 0, cy: 0, r: 1, ring: T.navn }, box: { photo: [0, 0, 0, 0], none: [0, 0, 0, 0] }, draw() { return ''; }
      };
    });
    Object.keys(ART).forEach(id => {
      const d = ART[id];
      BR.DESIGNS[id] = { name: d.name, swatch: d.swatch || '#fff', font: d.font || 'playfair', fastFont: !!d.fastFont, art: { iw: d.iw, ih: d.ih },
        colors: d.colors, photo: d.photo, box: d.box, max1: d.max1, max2: d.max2,
        draw(W, H, u, b) {
          const href = BR.asset ? BR.asset(d.url) : d.url, bw = W + 2*b, bh = H + 2*b, ar = d.iw / d.ih;
          let w = bw, h = bw / ar; if (h < bh) { h = bh; w = bh * ar; }
          return `<rect x="${-b}" y="${-b}" width="${bw}" height="${bh}" fill="${d.fill || '#FFFFFF'}"/>` +
            `<image href="${href}" xlink:href="${href}" x="${-b + (bw - w)/2}" y="${-b + (bh - h)/2}" width="${w}" height="${h}" preserveAspectRatio="none"/>`;
        } };
    });
    const orig = BR.render;
    BR.render = function (o) {
      const D = BR.DESIGNS[o.design];
      if (!D || !D.tema) return orig(o);
      const T = TEMA[D.tema], W = o.W, H = o.H, b = o.bleed || 0, M = o.marks ? 12 : 0, id = 'brt' + (++_n);
      const vx = -b - M, vy = -b - M, vw = W + 2*(b+M), vh = H + 2*(b+M);
      return `<svg data-tema="${D.tema}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="${vx} ${vy} ${vw} ${vh}" width="${vw}mm" height="${vh}mm">` +
        `<defs><clipPath id="${id}T"><rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}"/></clipPath></defs><g clip-path="url(#${id}T)">` +
        layout(o, T, W, H, b) + `</g>` + marks(o, W, H, b) + `</svg>`;
    };
    return BR;
  }
  if (root.BannerRender) patch(root.BannerRender);
  else {
    const prev = Object.getOwnPropertyDescriptor(root, 'BannerRender');
    let v;
    Object.defineProperty(root, 'BannerRender', { configurable: true, enumerable: true,
      get() { return prev && prev.get ? prev.get() : v; },
      set(x) { v = patch(x); if (prev && prev.set) prev.set(v); } });
  }

  // ---- Linje 3 i designeren + med i handlekurven ----
  if (typeof document === 'undefined') return;
  // Produktoppsett uten egen mal: produktmetafelt custom.banner_oppsett → window.BR_PROD = { designs, title, l1, l2, t1, t2, p1, p2, s1, note, usp }
  const P = root.BR_PROD;
  if (P) {
    const cfg = () => { const el = document.getElementById('br-cfg'); if (!el || el.__p) return; el.__p = 1;
      try { const c = JSON.parse(el.textContent || '{}'); Object.keys(P).forEach(k => { if (k !== 'usp' && P[k] != null) c[k] = P[k]; }); el.textContent = JSON.stringify(c); } catch (e) {} };
    const usp = () => { if (!P.usp) return; const ul = document.querySelector('.br-usp'); if (ul) ul.innerHTML = String(P.usp).split('|').map(u => '<li>' + esc(u.trim()) + '</li>').join(''); };
    const run = () => { cfg(); usp(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  }
  const rerender = () => { const l1 = document.getElementById('br-l1'); if (l1) l1.dispatchEvent(new Event('input')); };
  function addField(tries) {
    const l2 = document.getElementById('br-l2');
    if (!l2) { if ((tries || 0) < 100) setTimeout(() => addField((tries || 0) + 1), 100); return; }
    if (document.getElementById('br-l3')) return;
    const wrap = document.createElement('div'); wrap.className = 'br-field';
    wrap.innerHTML = `<input id="br-l3" maxlength="20" placeholder="Linje 3, f.eks. 5 år" autocomplete="off"><span class="br-count" id="br-c3">0/20</span>`;
    l2.closest('.br-field').after(wrap);
    const inp = wrap.querySelector('input'), cnt = wrap.querySelector('.br-count');
    inp.addEventListener('input', () => { cnt.textContent = inp.value.length + '/20'; rerender(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => addField(0)); else addField(0);
  if (document.fonts) Promise.all([document.fonts.load("700 50px 'Baloo 2'"), document.fonts.load('50px Pacifico')]).then(() => setTimeout(rerender, 50)).catch(() => {});

  const of = root.fetch;
  root.fetch = function (url, opt) {
    try {
      if (String(url).indexOf('cart/add') > -1 && opt && opt.body instanceof FormData && TEMA[String(opt.body.get('properties[_design]') || '')]) {
        const v = (document.getElementById('br-l3') || {}).value;
        if (v && v.trim()) opt.body.append('properties[Linje 3]', v.trim());
      }
    } catch (e) {}
    return of.apply(this, arguments);
  };
})(typeof window !== 'undefined' ? window : globalThis);